import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid-premium";
import { Tooltip } from "@mui/material";
import { renderDate } from "../../../formatting/dateFormat";

export const columns: GridColDef[] = [
  {
    field: "damage.upc",
    headerName: "UPC",
    description: "UPC(Universal Product Code)/ SKU (Stock Keeping Unit)",
    editable: true,
    valueGetter: (value, row) => row.damage?.upc,
  },
  {
    field: "damage.damage_shelf",
    headerName: "Damage Shelf",
    description: "Where the damaged inventory can be found in the warehouse",
    editable: true,
    valueGetter: (value, row) => row.damage?.damage_shelf,
  },
  {
    field: "supply.supply_title",
    headerName: "Title",
    description: "Yom's title for item (not Amazon's)",
    valueGetter: (value, row) => row.supply?.supply_title,
  },
  {
    field: "damage.status",
    headerName: "Status",
    description:
      "X: The product has been removed from its location in our facility and moved to a new location in the next step of the work order\n\nY: The item was unable to be located at its assigned location",
    editable: false,
    valueGetter: (value, row) => row.damage?.status,
  },
  {
    field: "damage.damage_qty",
    headerName: "DamageQty",
    description: "DamageQty",
    type: "number",
    valueGetter: (value, row) => row.damage?.damage_qty,
  },
  {
    field: "damage.damage_reason",
    headerName: "Damage Reason",
    description:
      "The damage type assigned to the product\n1: Can only be repaired\n2: Can be repaired or returned\n3: Can only be returned",
    editable: true,
    valueGetter: (value, row) => row.damage?.damage_reason,
    renderCell: (params: GridRenderCellParams) => {
      const data = params.value;
      let tooltipText = "";

      if (data === 1) {
        tooltipText = "Dislodged Disc and/or Unsealed";
      } else if (data === 2) {
        tooltipText = `Damaged\n- DVD Case < 1"\n- Single CD Case`;
      } else if (data === 3) {
        tooltipText = `Damaged\n- Paper / Cardboard\n- DVD Case > 1"\n- BluRay Case\n- Double CD Case`;
      } else if (data === 4) {
        tooltipText = "Missing or Cracked Disc / Wrong Item";
      } else if (data === 5) {
        tooltipText = "Misc.";
      }

      return (
        <Tooltip title={tooltipText} placement="top">
          <span style={{ cursor: "pointer" }}>{data}</span>
        </Tooltip>
      );
    },
  },
  {
    field: "damage.return_tracking",
    headerName: "ReturnTracking",
    description: "ReturnTracking",
    editable: true,
    valueGetter: (value, row) => row.damage?.return_tracking,
  },
  {
    field: "damage.date_reordered",
    headerName: "Date Reordered",
    description:
      "The date the product was reordered from a supplier (Manually added by Analyst)",
    type: "date",
    editable: true,
    valueGetter: (value, row) => row.damage?.date_reordered,
    valueFormatter: (value) => {
      return value ? renderDate(value) : null;
    },
  },
  {
    field: "damage.received",
    headerName: "Damage Date",
    description: "The date the product was scanned in as damaged",
    type: "date",
    valueGetter: (value, row) => row.damage?.received,
    valueFormatter: (value) => {
      return value ? renderDate(value) : null;
    },
  },
  {
    field: "damage.work_order",
    headerName: "Work Order",
    description:
      "The work order associated with the product\n.repair: This product must be repaired\n.return: This product must be returned",
    editable: false,
    valueGetter: (value, row) => row.damage?.work_order,
  },
  {
    field: "damage.note",
    headerName: "Damage Note",
    description: "Damage Note",
    editable: true,
    valueGetter: (value, row) => row.damage?.note,
  },
];
